import { render } from "./activity-card.component.vue?vue&type=template&id=ddd3d90e&ts=true"
import script from "./activity-card.component.vue?vue&type=script&lang=ts"
export * from "./activity-card.component.vue?vue&type=script&lang=ts"

import "./activity-card.component.vue?vue&type=style&index=0&id=ddd3d90e&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__